import SuggestionPanelComponent, { SUGGESTION_PANEL_BASE_HTML_CLASS } from "./suggestion_panel_component";

// IdentityPanel — the second step: who is submitting. Name + email (name first), or, when
// the submitter is already signed in, an identity row (their email + name) with a "Not you?"
// logout instead of the fields.
//
// Continue delegates to the host: signed in → submit straight away; signed out → the host
// emails a code (or routes to the password panel). Every auth panel behind this one carries
// a Skip, so a submitter who won't verify still gets through.
//
// Nothing person-specific is server-rendered here (the native profile is page cached per
// platform+version) — the email is prefilled and the identity row is populated client-side
// from the session-state detector, via the host.
export class IdentityPanel extends SuggestionPanelComponent {
  static get config() {
    return {
      componentTypeKey: "SuggestionIdentityPanel",
      baseHtmlClass: SUGGESTION_PANEL_BASE_HTML_CLASS,
      selector: ".suggestion_panel__panel--identity",
      phase: "identity",

      nameInputSelector: "input[name='suggestion[name]']",
      emailInputSelector: "input[name='suggestion[email]']",
      honeyPotSelector: ".suggestion_panel__honey_pot input",
      identityEmailSelector: ".suggestion_panel__identity_row__email",
      identityNameSelector: ".suggestion_panel__identity_row__name",
      logoutSelector: ".suggestion_panel__logout",
      backSelector: ".suggestion_panel__back",
      statusSelector: ".suggestion_panel__status",
    };
  }

  constructor(id_or_element, host) {
    super(id_or_element, host, IdentityPanel.config);
    const config = IdentityPanel.config;

    this.nameInput = this.element.querySelector(config.nameInputSelector);
    this.emailInput = this.element.querySelector(config.emailInputSelector);
    this.honeyPotInput = this.element.querySelector(config.honeyPotSelector);
    this.identityEmailEl = this.element.querySelector(config.identityEmailSelector);
    this.identityNameEl = this.element.querySelector(config.identityNameSelector);
    this.statusEl = this.element.querySelector(config.statusSelector);

    // Continue → the host decides submit-directly vs begin-verification.
    this.element.addEventListener("submit", (event) => {
      if (event) event.preventDefault();
      this.host.saveSuggestion();
    });

    const back = this.element.querySelector(config.backSelector);
    if (back) back.addEventListener("click", (event) => {
      if (event) event.preventDefault();
      this.host.backToContribution();
    });

    const logout = this.element.querySelector(config.logoutSelector);
    if (logout) logout.addEventListener("click", (event) => {
      if (event) event.preventDefault();
      this.host.logoutSession();
    });
  }

  getEmail() {
    return (this.emailInput && this.emailInput.value) || "";
  }

  // The address the host offers to the AuthClient / prefills: the signed-in person's own
  // address wins over a stale field value.
  prefillEmail(email) {
    if (!this.emailInput) return;
    if (this.emailInput.value) return;
    if (document.activeElement === this.emailInput) return;
    this.emailInput.value = email;
  }

  // On "Not you?" — clear the wrong person's prefilled fields.
  blankPersonFields() {
    if (this.nameInput) this.nameInput.value = "";
    if (this.emailInput) this.emailInput.value = "";
  }

  render() {
    const isActive = this.renderPanelVisibility();

    const person = this.readStateMachineValue("person");
    this.swapHtmlClassStates(!!person, "signed_in", "signed_out");
    if (person) {
      if (this.identityEmailEl) this.identityEmailEl.textContent = person.email || "";
      if (this.identityNameEl) this.identityNameEl.textContent = person.name || "";
    }

    this.applyBusy([this.nameInput, this.emailInput]);
    this.renderAuthStatus(this.statusEl);

    return isActive;
  }
}
